<div class="image-modal" (click)="onClose()">
  <img [src]="image" alt="">
</div>
